/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundGroupCreateUpdateRequestDto
 */
export interface FundGroupCreateUpdateRequestDto {
  /**
   *
   * @type {string}
   * @memberof FundGroupCreateUpdateRequestDto
   */
  name: string;
}

export function FundGroupCreateUpdateRequestDtoFromJSON(json: any): FundGroupCreateUpdateRequestDto {
  return FundGroupCreateUpdateRequestDtoFromJSONTyped(json, false);
}

export function FundGroupCreateUpdateRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundGroupCreateUpdateRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function FundGroupCreateUpdateRequestDtoToJSON(value?: FundGroupCreateUpdateRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
  };
}
